import { v4 as uuidv4 } from 'uuid';
import * as actionTypes from './actionTypes';

const providerTypePayload = {
  systemParameter: [],
  defaultAudit: [],
  defaultSystemParameter: [],
  defaultUnitTypeAudit: [],
  generalSystemParameter: [],
  holiday: [],
  mdspecthera: [],
  nmFinCodes: [],
  nmAccountNumber: [],
  error: [],
  errorMessages: [],
  successMessage: [],
  tabValue: 0,
  disabledSaveCancelBtn: true,
};

const reducer = (state = providerTypePayload, action) => {
  switch (action.type) {
    case actionTypes.GET_SYSTEM_PARAMETER: {
      return { ...state, systemParameter: action.systemParameter };
    }
    case actionTypes.GET_DEFAULT_AUDIT: {
      return { ...state, defaultAudit: action.defaultAudit };
    }
    case actionTypes.GET_DEFAULT_SYSTEM_PARAMETER: {
      return {
        ...state,
        defaultSystemParameter: action.defaultSystemParameter,
      };
    }
    case actionTypes.GET_GENERAL_SYSTEM_PARAMETER: {
      return {
        ...state,
        generalSystemParameter: action.generalSystemParameter,
      };
    }
    case actionTypes.GET_DEFAULT_UNIT_TYPE_AUDIT: {
      return { ...state, defaultUnitTypeAudit: action.defaultUnitTypeAudit };
    }
    case actionTypes.GET_HOLIDAY: {
      return { ...state, holiday: action.holiday };
    }
    case actionTypes.SET_HOLIDAY: {
      return { ...state, holiday: action.payload };
    }
    case actionTypes.SET_HOLIDAY: {
      return { ...state, holiday: action.holidayUpdateData };
    }
    case actionTypes.GET_MD_SPEC_THERA: {
      return { ...state, mdspecthera: action.mdspecthera };
    }
    case actionTypes.SET_MD_SPEC_THERA: {
      return { ...state, mdspecthera: action.payload };
    }
    case actionTypes.SET_SPEC_IN_SYS:
      return { ...state, specinsys: action.payload };
    case actionTypes.GET_NM_FIN_CODE: {
      return {
        ...state,
        nmFinCodes: action.nmFinCodes?.map((item) => {
          if (!item.id) {
            item.id = uuidv4();
            item.oldNMFinStartQtr = item?.rpcArInterfaceIdVO?.nmFinStartQtr;
            item.oldNMFinBudgetRef = item?.rpcArInterfaceIdVO?.nmFinBudgetRef;
            item.oldNMFinClass = item?.rpcArInterfaceIdVO?.nmFinClass;
            item.startQtrErr = false;
            item.nmFinBudgetRefErr = false;
            item.nmFinClassErr = false;
            item.isDeleteFlag = false;
          }
          return item;
        }),
      };
    }
    case actionTypes.GET_NM_FIN_CODE_UPDATE: {
      return { ...state, nmFinCodeUpdate: action.nmFinCodeUpdate };
    }
    case actionTypes.MAX_DT_AR_ACTIVITY:
      return { ...state, maxActivityDt: action.payload };
    case actionTypes.UPDATE_SYSTEM_PARAM: {
      return { ...state, updatedSystemDetails: action.updatedSystemDetails };
    }
    case actionTypes.SET_NM_ACC_IN_SYS:
      return { ...state, nmAccInSys: action.payload };
    case actionTypes.SET_NM_FIN_IN_SYS:
      return { ...state, nmFinInSys: action.payload };
    case actionTypes.GET_NM_ACCOUNT_NUMBER: {
      return {
        ...state,
        nmAccountNumber: action.nmAccountNumber?.map((item) => {
          if (!item.id) {
            item.id = uuidv4();
            item.oldStartQtr = item?.nmAccountIdVO?.startQtr;
            item.oldFileType = item?.nmAccountIdVO?.fileType;
            item.oldAccountNumber = item?.nmAccountIdVO?.accountNumber;
            item.startQtrErr = false;
            item.fileTypeErr = false;
            item.accountNumberErr = false;
          }
          return item;
        }),
      };
    }
    case actionTypes.UPDATE_NM_FINE_CODE: {
      return {
        ...state,
        updateNMFineCodeDetails: action.updateNMFineCodeDetails,
      };
    }
    case actionTypes.SET_SYSTEM_PARAMETER_PAYLOAD: {
      return {
        ...state,
        systemParameterPayload: action.systemParameterPayload,
      };
    }
    case actionTypes.SET_DEFAULT_AUDIT_DATA: {
      return { ...state, defaultAuditDataRedux: action.defaultAuditDataRedux };
    }
    case actionTypes.SET_GEN_SYS_PARAM_DATA: {
      return { ...state, genSysParamData: action.genSysParamData };
    }
    case actionTypes.SET_DEF_SYS_PARAM_DATA: {
      return { ...state, defSysParamData: action.defSysParamData };
    }
    case actionTypes.SET_ERROR_MESSAGES: {
      return { ...state, errorMessages: action.payload };
    }
    case actionTypes.SET_SUCCESS_MESSAGES: {
      return { ...state, successMessage: action.payload };
    }
    case actionTypes.SET_TAB_VALUE: {
      return { ...state, tabValue: action.payload };
    }
    case actionTypes.SET_DISABLED_SAVE_CANCEL_BTN: {
      return { ...state, disabledSaveCancelBtn: action.payload };
    }
    case actionTypes.SELECTED_UNIT_DEFAULT_CODE:
      return { ...state, selectedCode: action.payload };

    case actionTypes.RESET_SYSTEM_PARAMETER_STORE: {
      return { ...providerTypePayload };
    }
    case actionTypes.VALIDATE_NMACCOUNT_NUMBER: {
      return { ...state, isValidDeleteNMAccountNo: action.payload };
    }
    case actionTypes.VALIDATE_NMFIN_CODE: {
      return { ...state, isValidDeleteNMFinCd: action.payload };
    }
    case actionTypes.UPDATE_DEFAULT_AUDIT_DATA:{
      console.log("consumed")
      return {
        ...state,
        defaultAudit:{
          ...state.defaultAudit,
          data: {...state.defaultAudit?.data,
          paramTestVO:action.payload}
        }
      }
    }
    default:
      return state;
  }
};

export default reducer;
